import type { AxiosError, AxiosInstance } from "axios"
import { Web } from "@infinitaslearning/auth-first-party-core"
import { history } from "../redux/Store"

export function errorInterceptor(instance: AxiosInstance) {
  instance.interceptors.response.use(
    (response) => {
      return response
    },
    (error: AxiosError) => {
      if (error?.response?.status === 401) {
        Web.getUser(window.location.href).then((user) => {
          if (!user) {
            Web.getLoginUrl().then((loginUrl) => {
              window.location.href = loginUrl
            })
          }
        }).catch(() => {
          Web.getLoginUrl().then((loginUrl) => {
            window.location.href = loginUrl
          })
        })
      } else if (error?.response?.status === 403) {
        history.push("/unauthorized")
      }
    }
  )
}
